import moment from 'moment';

export const currentDate = () => {
  const today = moment();
  return today.format('YYYY-MM');
};
